module.exports = __webpack_public_path__ + "7e224dbb0b0a96b6618177d540abbf0c.pdf";